import { FunctionComponent } from "react";
import NAV from "../components/NAV";

const Lesson7: FunctionComponent = () => {
  return (
    <div className="relative bg-gray-100 w-full overflow-hidden flex flex-col items-center justify-center p-[2.69rem] box-border gap-[6.88rem] text-left text-[1.88rem] text-darkgray font-nunito">
      <NAV dimensionCode="/nav@2x.png" navIconFlexShrink="0" />
      <div className="self-stretch shrink-0 flex flex-row items-center justify-between text-[1.56rem]">
      <a className="cursor-pointer text-darkgray no-underline" href={"/lesson6"}>
        <div className="flex-1 rounded-32xl bg-gainsboro-200 box-border h-[3.5rem] flex flex-col items-center justify-center py-[0.69rem] px-[3rem] max-w-[12.5rem] border-[1px] border-solid border-gray-300">
          <b className="relative inline-block w-[3.75rem] h-[2.06rem] shrink-0">
            Back
          </b>
        </div>
        </a>
        <div className="self-stretch flex-1 flex flex-col items-center justify-center text-center text-[2.81rem] text-white">
          <b className="self-stretch relative leading-[100%]">Sleep</b>
        </div>
        <a className="cursor-pointer text-darkgray no-underline" href={"/lesson8"}>
        <div className="flex-1 rounded-32xl bg-gainsboro-200 box-border h-[3.5rem] flex flex-col items-center justify-center py-[0.69rem] px-[3rem] max-w-[12.5rem] border-[1px] border-solid border-gray-300">
          <b className="relative inline-block w-[3.75rem] h-[2.06rem] shrink-0">
            Next
          </b>
        </div>
        </a>
      </div>
      <div className="flex flex-col items-center justify-center gap-[6.25rem] text-justify text-white font-dm-sans">
        <div className="self-stretch flex flex-row items-center justify-center gap-[6.25rem]">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <p className="m-0">
              <b>
                <span>Importance of Sleep?</span>
              </b>
            </p>
            <p className="m-0 text-gainsboro-100">
              <span>
                <b>&nbsp;</b>
              </span>
            </p>
            <p className="m-0 text-[1.56rem]">
              <span>
                <span>
                  Despite the fact that many people today think that sleeping
                  less makes them look more hard-working and disciplined, the
                  reality is that prioritizing sleep is not a sign of laziness.
                  In fact, sleep is extremely important for our health and
                  well-being. It affects the functioning of almost every type of
                  tissue and system in the body, including the brain, heart,
                  lungs, and others. As such, sleep has a major impact on our
                  metabolism, immune function, and overall health.
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>&nbsp;</span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  Research has shown that sleep is also essential for body
                  recomposition, which is the process of losing fat and gaining
                  muscle. A study published in 2018 by Wang and colleagues found
                  that people who slept for 8 hours per night lost more fat and
                  less muscle than people who slept for only 5 hours per night.
                  Even though both groups lost the same amount of weight, the
                  group that slept for 5 hours per night lost twice as much
                  muscle as the group that slept for 8 hours per night.
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>&nbsp;</span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  Another study found that people who slept for 5.5 hours per
                  night lost 80% of their weight from fat-free mass (including
                  muscle), while people who slept for 8.5 hours per night lost
                  only 20% of their weight from fat-free mass.
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>&nbsp;</span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  These studies show that getting enough sleep is essential for
                  body recomposition. If you want to lose fat and gain muscle,
                  it is important to make sure that you are getting at least 7-8
                  hours of sleep per night.
                </span>
              </span>
            </p>
          </div>
          <img
            className="relative w-[32rem] h-[38.75rem] object-cover"
            alt=""
            src="/8@2x.png"
          />
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b>
              <span>Tips For Getting Better Sleep</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <ul className="m-0 text-[1rem] pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  Stick to a regular sleep schedule. Go to bed and wake up at
                  the same time each day, even on weekends.
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  Create a relaxing bedtime routine. This could include taking a
                  warm bath, reading a course, or listening to calming music.
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  Avoid caffeine and alcohol before bed. These substances can
                  interfere with sleep.
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  Avoid going on your phone or viewing any blue light at least 1
                  hour before falling asleep.
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  Make sure your bedroom is dark, quiet, and cool. These
                  conditions are ideal for sleep.
                </span>
              </span>
            </li>
            <li>
              <span>
                <span>
                  If you can't fall asleep after 20 minutes, get out of bed and
                  do something relaxing until you feel tired. Lying in bed awake
                  will only make it harder to fall asleep.
                </span>
              </span>
            </li>
          </ul>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-[1.56rem]">
          <p className="m-0 text-[1.88rem]">
            <b>
              <span>
                <span>{`Scientific Methods To Increase Sleep Quality & Wakefullness`}</span>
              </span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>
                <span>&nbsp;</span>
              </b>
            </span>
          </p>
          <ul className="m-0 text-[1rem] pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  <b>Light:</b>
                  <span>
                    {" "}
                    Exposure to natural light, particularly in the first 30-60
                    minutes after waking, plays a crucial role in setting the
                    body's internal clock and promoting wakefulness. This is due
                    to the effect of light on suppressing the sleep-inducing
                    hormone melatonin. Additionally, exposure to sunlight in the
                    evening helps signal to the body that it's time to wind down
                    and prepares it for sleep. This is particularly important in
                    the context of avoiding the negative effects of artificial
                    light before bed, which can disrupt the sleep-wake cycle.
                  </span>
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  <b className="font-dm-sans">Exercise:</b>
                  <span>
                    {" "}
                    Engaging in exercise within the first hour after waking can
                    help increase body temperature and promote wakefulness.
                    However, exercising later in the day, especially close to
                    bedtime, can have the opposite effect and make it harder to
                    fall asleep. It's recommended to schedule workouts earlier
                    in the day to allow sufficient time for the body to wind
                    down before bedtime.
                  </span>
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  <b className="font-dm-sans">Shower:</b>
                  <span>
                    {" "}
                    Taking a cold shower within the first hour of waking can
                    raise core body temperature and aid in waking up. On the
                    other hand, a warm shower or bath for less than 20 minutes
                    can help cool down the body's core temperature, which is
                    beneficial for initiating sleep. Taking a warm shower after
                    late evening exercise can help counteract any potential
                    negative effects on sleep.
                  </span>
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  <b className="font-dm-sans">Drugs:</b>
                  <span>
                    {" "}
                    Caffeine intake should be timed strategically to optimize
                    both wakefulness and sleep. It's recommended to consume
                    caffeine at least 90-120 minutes after waking to avoid
                    interfering with the natural energy cycle and prevent an
                    afternoon crash. Additionally, it's advised to avoid
                    caffeine intake within 8-10 hours before bedtime to minimize
                    its disruptive effects on sleep.
                  </span>
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  <b className="font-dm-sans">Temperature:</b>
                  <span>
                    {" "}
                    Creating a cool sleep environment, typically around 3
                    degrees cooler than the rest of the room, promotes better
                    sleep.
                  </span>
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  <b className="font-dm-sans">Catch-up Sleep:</b>
                  <span>
                    {" "}
                    If sleep has been compromised, implementing a strategic
                    approach to catch-up sleep is essential. The NSDR (non-sleep
                    deep rest) technique involves taking a nap of no more than
                    90 minutes, ensuring the nap doesn't occur close to bedtime.
                  </span>
                </span>
              </span>
            </li>
          </ul>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-[1.56rem] text-gainsboro-100">
          <p className="m-0 text-[1.88rem] text-white">
            <b>Importance Of Sleep</b>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>May help you maintain or lose weight</span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>Can improve concentration and productivity</span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>Can maximize athletic performance</span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>May strengthen your heart</span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>Affects sugar metabolism and type 2 diabetes risk</span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>Poor sleep is linked to depression</span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>Supports a healthy immune system</span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>Poor sleep is linked to increased inflammation</span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>Affects emotions and social interactions</span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0 text-orangered-100">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0 text-[1.88rem] text-white">
            <b>The Bottom Line</b>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            Along with nutrition and exercise, taking care of your sleep is one
            of the pillars of health.
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            Lack of sleep is associated with many negative health effects,
            including increased risk of heart disease, depression, weight gain,
            inflammation, and sickness.
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">{`Though individual needs vary, most research suggests that you should get between 7 and 9 hours of sleep per night for optimal health. `}</p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            Just like you prioritize your diet and physical activity, it’s time
            to give sleep the attention it deserves.
          </p>
        </div>
        <img
          className="relative w-[38.94rem] h-[39.81rem] object-cover"
          alt=""
          src="/9@2x.png"
        />
      </div>
      <a className="cursor-pointer text-darkgray no-underline" href={"/lesson8"}>
        <div className="rounded-32xl bg-gainsboro-200 box-border w-[25rem] flex flex-col items-center justify-center pt-[0.69rem] px-[3rem] pb-[1rem] max-w-[31.25rem] text-center text-[1.88rem] border-[1px] border-solid border-gray-300">
          <b className="self-stretch relative">Next Chapter</b>
        </div>
      </a>
    </div>
  );
};

export default Lesson7;
